export default __webpack_public_path__ + "static/media/absorbants.1742245b.webp";